import { ContainerModule, WebuiIocKey } from '@ztechapps/webui.contract'
import { ProductSelect } from './ProductSelect/ProductSelect'
import { ProductSelectCreatable } from './ProductSelect/ProductSelectCreatable'
import { ProductQuantity } from './ProductQuantity'
import { ProductWidget } from './ProductWidget'

export const productContainer = new ContainerModule((bind) => {
  bind(WebuiIocKey.product.productSelect).to(ProductSelect)
  bind(WebuiIocKey.product.productSelectCreatable).to(ProductSelectCreatable)
  bind(WebuiIocKey.product.productQuantity).to(ProductQuantity)
  bind(WebuiIocKey.product.productWidget).to(ProductWidget)
})
